import { ValidatorService } from '../tools/validator.service';
import { AutenticacionService } from '../autenticacion.service';
import { Http, URLSearchParams } from '@angular/http';
import { ConstantsService } from '../constants.service';
import { Injectable } from '@angular/core';
import { ErrorsService } from '../tools/errors.service';

@Injectable()
export class CarburacionesUnidadesService {

  private service_url : string = '';
  constructor(
      private constantsService: ConstantsService, 
      private http: Http, 
      private authService: AutenticacionService, 
      private validatorService: ValidatorService, 
      private errorService: ErrorsService) {
    this.service_url = this.constantsService.apiURL + '/carburacionesUnidades';
  }

  public get(idCreditos : number) {
    let myParams = new URLSearchParams();
    myParams.append('idCreditos', idCreditos.toString());

    let myoptions = this.authService.getAuthHeaders();
    myoptions.params = myParams;
    
    return this.http.get(this.service_url , myoptions);
  }

  public save( credito : object) {
    return this.http.post(this.service_url , credito, this.authService.getAuthHeaders());
  }

  public update( credito : object) {
    return this.http.put(this.service_url , credito, this.authService.getAuthHeaders());
  }


  public validate(unidad : any){
    let error = [];

    if(!this.validatorService.required(unidad.marca)){
      error["marca"] = this.errorService.required;
    }

    if(!this.validatorService.required(unidad.modelo)){
      error["modelo"] = this.errorService.required;
    }

    if(!this.validatorService.required(unidad.color)){
      error["color"] = this.errorService.required;
    }

    if(!this.validatorService.required(unidad.numero_serie)){
      error["numero_serie"] = this.errorService.required;
    }

    if(!this.validatorService.required(unidad.placa)){
      error["placa"] = this.errorService.required;
    }

    if(!this.validatorService.required(unidad.kilometraje)){
      error["kilometraje"] = this.errorService.required;
    } 

    if(!this.validatorService.required(unidad.uso_unidad)){
      error["uso_unidad"] = this.errorService.required;
    }

    if(!this.validatorService.required(unidad.numero_economico)){
      error["numero_economico"] = this.errorService.required;
    }

    return error;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/creditos/carburaciones-unidades.service.ts